import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountUserRegistrationSource = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectUserRegistrationSource);
};
